// extracted by mini-css-extract-plugin
module.exports = {"buttonAddProperty":"styles_buttonAddProperty__3-KCZ","badge":"styles_badge__1h1lV","badgeDelete":"styles_badgeDelete__2i6ZI"};